<template>
  <transition name="slide-fade" mode="out-in" >
    
    <div :key="0" v-if="currentSection === 0">
      <h4>
        Workflow Automation
      </h4>
      <p>
        Computers are meticulous and tireless.  If you find yourself performing repetitive tasks on one, it may be time to have it do the work for you.
      </p>
      <p>
        We'll provide the tools you need to realize the full potential of your computer, whether it's automating your work in Excel or enabling efficient parametric analysis of an engineering model.
      </p>
    </div>

    <div key="1" v-if="currentSection === 1">
      <h4>
        Custom Utilities
      </h4>
      <p>
        If you can imagine a program that would alleviate an inconvenience or improve your workflow efficiency, let us create it for you!
      </p>
      <p>
        We enjoy developing tools designed to address specific needs because we have a passion for using computers to their full potential and take joy in showing people what is possible.
      </p>
    </div>


    <div key="2" v-if="currentSection === 2">
      <h4>
        Custom Interfaces
      </h4>
      <p>
        As a program or application gets more sophisticated, its graphical user interface (GUI) typically becomes more complicated.  On the other end of the spectrum, there are programs without any kind of graphical interface that are designed to be used from the command line.
      </p>
      <p>
        For these types of applications, a custom GUI tailored to your specific needs will increase efficiency and reduce frustration.
      </p>
    </div>


    <div key="3" v-if="currentSection === 3">
      <h4>
        Web Applications
      </h4>
      <p>
        Hosting software in the cloud has many benefits, and creating a web application has never been easier.  Whether you need help deciding on a hosting provider or navigating the many JavaScript frameworks available today, we can provide everything you need to get your code in the cloud.
      </p>
    </div>

    <div key="4" v-if="currentSection === 4">
      <h4>
        Code Profiling
      </h4>
      <p>
        Often a program can seem "fast enough" during development, only to become "way too slow"
        when used for parametric studies or optimization analyses.
        If this is the case, we can identify the performance bottlenecks in your code and implement
        more efficient methods.
      </p>
    </div>

    <div key="5" v-if="currentSection === 5">
      <h4>
        Education and Support
      </h4>

      <p>The better you understand a tool, the more effectively you can apply it.  We place a strong emphasis on providing you the knowledge you need to use, modify, and extend any code we provide you.  We also believe in promoting programming best practices and will help you understand the reasoning behind our design choices.
      </p>

      <p>Ultimately, we want you to be more effective when you work on your computer.  One of the ways we do this is to provide the best support we can for our clients.  We're always available to answer your questions, and we'll be there to help as your needs change in the future.
      </p>
    </div>

  </transition>
</template>




<script>
export default {
  name: 'SectionContent',
  props: {
    currentSection: Number,
  },
}
</script>




<style scoped>
h4 {
  text-align: center;
  font-weight: bold;
  font-size: 120%;
  padding-bottom: 15px;
}
p {
  line-height: 120%;
  padding-bottom: 15px;
}
.slide-fade-enter-active {
  transition: opacity 0.5s ease-in, transform 0.5s linear;
}
.slide-fade-leave-active {
  transition: opacity 0.5s ease-out, transform 0.5s linear;
}
.forward .slide-fade-enter {
  transform: translateX(150px);
  opacity: 0;
}
.forward .slide-fade-leave-to {
  transform: translateX(-150px);
  opacity: 0;
}
.back .slide-fade-enter {
  transform: translateX(-150px);
  opacity: 0;
}
.back .slide-fade-leave-to {
  transform: translateX(150px);
  opacity: 0;
}
</style>
